export interface EmployeeData {
  EmployeeNo?: string;
  LastName?: string;
}

import { TripLeg } from './trip-leg';

export interface UserData {
  rebcode?: string;
  rebuid?: number;
  evtuid?: Int16Array;
  /** Login/package evtPmsCode; stable identifier from AX login (not overwritten per leg). */
  evtPmsCode?: string;
  evtcode?: string;
  shipid?: number;
  ShipName?: string;
  cruiseBeg?: Date | string;
  cruiseEnd?: Date | string;
  pckgBeg?: Date | string;
  pckgEnd?: Date | string;
  loyaltynum?: string;
  extended?: boolean;

  legs?: TripLeg[];
  packagePckgBeg?: Date | string;
  packageCruiseEnd?: Date | string;
}

export class EmployeeAndUserData {
  employeeData: EmployeeData;
  userData: UserData;

  constructor(employeeData: EmployeeData, userData: UserData) {
    this.employeeData = employeeData;
    this.userData = userData;
  }
}